import { UserInfoCardTemplate, UserInfoCardTemplateProps } from "./template";

export type UserInfoCardProps = UserInfoCardTemplateProps;

export const UserInfoCard = (props: UserInfoCardTemplateProps): JSX.Element => {
  return <UserInfoCardTemplate {...props} />;
};
